import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a4d0f35"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "request-access-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "request-access-container-title" }, "Request an access", -1));
const _hoisted_3 = { class: "request-access-container-desc" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "You are about to request an access to", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "to be able to execute a Load Testing or SEO crawl at anytime. To get this request approved quickly, please tell us in a few words your intentions.", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "request-access-container-reason-label" }, "Reason of claim", -1));
const _hoisted_7 = { class: "wp-block-button-row" };
import { computed, ref } from "vue";
import Textarea from "primevue/textarea";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { ClaimType } from "@/entities/claim.entity";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskRequestAccess',
    props: {
        fullUrl: {},
        siteName: {},
        brand: {},
        market: {},
        onSendRequest: { type: Function },
        onCancelRequest: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const requestInput = ref("");
        const claimType = ref(ClaimType.CAN_ACCESS_SITENAME);
        const restrictedFeaturesOptions = computed(() => [
            { label: `Site : ${props.fullUrl}`, value: ClaimType.CAN_ACCESS_SITENAME },
            { label: `Brand : ${props.brand}`, value: ClaimType.CAN_ACCESS_BRAND },
            { label: `Market : ${props.market}`, value: ClaimType.CAN_ACCESS_MARKET },
        ]);
        const notify = useToastNotify();
        const sendRequest = () => {
            switch (claimType.value) {
                case ClaimType.CAN_ACCESS_BRAND:
                    props.onSendRequest(ClaimType.CAN_ACCESS_BRAND, props.brand, requestInput.value);
                    break;
                case ClaimType.CAN_ACCESS_MARKET:
                    props.onSendRequest(ClaimType.CAN_ACCESS_MARKET, props.market, requestInput.value);
                    break;
                case ClaimType.CAN_ACCESS_SITENAME:
                    props.onSendRequest(ClaimType.CAN_ACCESS_SITENAME, props.siteName, requestInput.value);
                    break;
            }
            notify("Request an access", "Your request has been successfully sent", "success");
        };
        const cancelRequest = () => {
            props.onCancelRequest();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("p", null, [
                            _createVNode(OneDeskDropdown, {
                                modelValue: claimType.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((claimType).value = $event)),
                                options: restrictedFeaturesOptions.value,
                                class: "w-full md:w-14rem"
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _hoisted_5
                    ]),
                    _hoisted_6,
                    _createVNode(_unref(Textarea), {
                        modelValue: requestInput.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((requestInput).value = $event)),
                        class: "request-access-container-reason-input",
                        "auto-resize": true,
                        rows: "5",
                        cols: "30",
                        placeholder: "Example : As a brand manager, I want to take advantage of SEO feature to test the different French websites in order to increase my traffic."
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(OneDeskButton, {
                        icon: "pi pi-check",
                        class: "wp-launch-button request-button",
                        label: "Request an access",
                        "with-radius": true,
                        onClick: sendRequest
                    }),
                    _createVNode(OneDeskButton, {
                        icon: "pi pi-times-circle",
                        class: "cancel-button",
                        label: "Cancel",
                        "with-radius": true,
                        onClick: cancelRequest
                    })
                ])
            ], 64));
        };
    }
});
